export enum CSVProtocolTypes {
	SFTP = 'SFTP',
	FTP = 'FTP',
	SMB = 'SMB',
	HTTP = 'HTTP',
	HTTPS = 'HTTPS',
}

export enum SQLProtocolTypes {
	MYSQL = 'MYSQL'
}

export enum ServiceProtocolTypes {
	DOCKER= 'DOCKER'
}

export enum EmailProtocolTypes {
	MAIL= 'MAIL'
}

